import { useContext, useEffect, useState } from 'react';
import { UserContext } from '../contexts/UserContext';
import { Container, Stack, Button, Form, Modal } from 'react-bootstrap';
import avatar from '../avatar/avatar.svg';
import Icon from '@mdi/react';
import {mdiPencil, mdiEyeOff, mdiEye } from '@mdi/js';
import { baseUrl, patchRequest, getRequest } from '../utils/services';

const Profile = () => {

	const { user } = useContext(UserContext);
	const [editError, setEditError] = useState(false);
	const [name, setName] = useState('');
	const [password, setPassword] = useState('');
	const [showName, setShowName] = useState(false);
	const [showPassword, setShowPassword] = useState(false);
	const [updatedUser, setUpdatedUser] = useState();
	const [secretPassword, setSecretPassword] = useState();
	const [seePassword, setSeePassword] = useState(false);


	const findUser = async(e) => {
		// e.preventDefault();

		const response = await getRequest(`${baseUrl}/users/find/${user._id}`)

		if(response.error){
			console.log(response);
		}
		setUpdatedUser(response);

	}

	useEffect(() => {
		findUser();
	}, [])

	const showNameModal = () => {
		setShowName(true);
		setName(user.name);
	}

	const showPasswordModal = () => {
		setShowPassword(true);
		setPassword(user.password);
	}

	const handleClose = () => {
		setShowName(false);
		setShowPassword(false);
	}

	const editName = async(e) => {
		// e.preventDefault();
		const response = await patchRequest(`${baseUrl}/users/edit/${user._id}`, JSON.stringify({
			name: name
		}))

		if(response.error){
			return setEditError(response);
		}
		setName('');
		findUser(e);
		handleClose();
	}

	const editPassword = async(e) => {
		e.preventDefault();
		const response = await patchRequest(`${baseUrl}/users/edit/${user._id}`, JSON.stringify({
			password: password
		}))

		if(response.error){
			return setEditError(response);
		}
		setPassword('');
		findUser(e);
		handleClose();
	}

	const revealPassword = () => {
		setSeePassword(true);

	}
	
	const hidePassword = () => {
	  	let passwordLength = user.password.length;
	  	let newPass = "";

	  	for(let index=0; index < passwordLength; index++){
	    	newPass += "*";
	  	}

	  	setSecretPassword (newPass);
	  	setSeePassword(false);
	}
	
	useEffect(() => {
		hidePassword();
	}, [user])

	return(
		<>
		<Container>
			<Stack>
				<Stack className="mt-5 mt-md-2">
					<img src={avatar} style={{height: '200px'}}/>
				</Stack>
				<Stack className="text-center mt-5">
					<h1>Account Details</h1>
				</Stack>
				<Stack className="mx-auto mt-5" gap={4}>
					<Stack direction="horizontal" gap={5}>
						<h2>Name: {updatedUser?.name}</h2>
						<Icon path={mdiPencil} size={1} role="button" onClick={showNameModal}/>
					</Stack>
					<h2>Email: {user.email}</h2>
					<Stack direction="horizontal" gap={5}>
						{seePassword?
						<>
						<h2>Password: {user.password}</h2>
						<Icon path={mdiEyeOff} size={1} role="button" onClick={hidePassword}/>
						</>
						:
						<>
						<h2>Password: {secretPassword}</h2>
						<Icon path={mdiEye} size={1} role="button" onClick={revealPassword}/>
						</>
						}
						<Icon path={mdiPencil} size={1} role="button" onClick={showPasswordModal}/>
					</Stack>
					<h2>User ID: {user._id}</h2>
				</Stack>
			</Stack>
		</Container>


		{/*Modal for Editing name*/}
		<Modal show={showName} onHide={handleClose}>
		  	<Modal.Header closeButton>
		    	<Modal.Title>Edit name</Modal.Title>
		  	</Modal.Header>
		  	<Modal.Body>
		    	<Form onSubmit={e => editName(e)}>
		      		<Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
		        		<Form.Label>Name</Form.Label>
				        <Form.Control
				          type="text"
				          placeholder="Type your name"
				          // autoFocus
				          onChange={e => setName(e.target.value)}
				          value={name}
				        />
		      		</Form.Group>
		      	</Form>
		  	</Modal.Body>
		  	<Modal.Footer>
		    	<Button variant="secondary" onClick={handleClose}>Close</Button>
		    	<Button variant="primary" onClick={editName} type="submit">Save Changes</Button>
		  	</Modal.Footer>
		</Modal>
		

		{/*Modal for Editing password*/}
		<Modal show={showPassword} onHide={handleClose} >
		  	<Modal.Header closeButton>
		    	<Modal.Title>Edit password</Modal.Title>
		  	</Modal.Header>
		  	<Modal.Body>
		    	<Form onSubmit={e => editPassword(e)}>
  		      		<Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
  		        		<Form.Label>Password</Form.Label>
  				        <Form.Control
  				          type="text"
  				          placeholder="Type your password"
  				          // autoFocus
  				          onChange={e => setPassword(e.target.value)}
  				          // value={password}
  				        />
  		      		</Form.Group>
		    	</Form>
		  	</Modal.Body>
		  	<Modal.Footer>
		    	<Button variant="secondary" onClick={handleClose}>Close</Button>
		    	<Button variant="primary" onClick={editPassword} type="submit">Save Changes</Button>
		  	</Modal.Footer>
		</Modal>
		</>
	)
}

export default Profile;


// import { useState } from 'react';
// import Button from 'react-bootstrap/Button';
// import Form from 'react-bootstrap/Form';
// import Modal from 'react-bootstrap/Modal';

// function Example() {
//   const [show, setShow] = useState(false);

//   const handleClose = () => setShow(false);
//   const handleShow = () => setShow(true);

//   return (
//     <>
//       <Button variant="primary" onClick={handleShow}>
//         Launch demo modal
//       </Button>

      
//     </>
//   );
// }

// export default Example;